import Card from '@mui/material/Card';
import PropTypes from 'prop-types';
import { cardItem, cardText } from './Styles';
import { useMaterialUIController } from 'context';
import MDBadge from 'components/MDBadge';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useState } from 'react';
import { CardActionArea } from '@mui/material';

const HomeCard = ({ badgeContent, imgLightSource, imgDarkSource, text }) => {
  const [controller] = useMaterialUIController();
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode } = controller;

  function handleMouseOver() {
    setIsHovered(true);
  }

  function handleMouseOut() {
    setIsHovered(false);
  }

  return (
    <CardActionArea onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      <Card
        variant="outlined"
        sx={(theme) =>
          cardItem(theme, {
            darkMode,
          })
        }>
        <MDBadge
          badgeContent={badgeContent || 0}
          color="error"
          indicator={true}
          size="lg"
          rounded={badgeContent >= 10}
          circular={badgeContent < 10}>
          <MDBox
            component="img"
            //! this could be cleaned better
            src={
              darkMode
                ? isHovered
                  ? imgLightSource
                  : imgDarkSource
                : isHovered
                ? imgDarkSource
                : imgLightSource
            }
            alt="new_sendback"
            width="10rem"
            mr={1}
            pb={1}
          />
        </MDBadge>
        <MDTypography
          variant="h4"
          sx={(theme) =>
            cardText(theme, {
              darkMode,
              isHovered,
            })
          }
          noWrap // Prevents the text from wrapping to a new line
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }} // Ensures text does not wrap
        >
          {text}
        </MDTypography>
      </Card>
    </CardActionArea>
  );
};

HomeCard.propTypes = {
  badgeContent: PropTypes.number,
  imgLightSource: PropTypes.node.isRequired,
  imgDarkSource: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
};

export default HomeCard;
